import superMeta from '../_BASE/metaBaseNode.mjs'

export default {
    ...superMeta,
    classes: ['pseudo', ...superMeta.classes],
}
